import ApiFetcher2 from 'static/three-oh/src/modules/apis/ApiFetcher2';

export default class LessonSparkApi {
  static get(contentId) {
    return ApiFetcher2.get(`lesson-spark/${contentId}/`);
  }
}
